import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const CommonText = ({
  className,
  children,
  color = '#000000',
  fontWeight = '400',
  fontSize = 14,
  tag = 'span',
  link,
  onClick,
  ...props
}) => {
  const Tag = tag
  const textStyle = {
    color,
    fontWeight,
    fontSize,
    tag,
    textDecoration: 'none',
  }
  return (
    <>
      {tag === 'a' ? (
        <Link
          to={link}
          className={className}
          style={{ ...textStyle, ...props.style }}
          onClick={onClick}>
          {children}
        </Link>
      ) : (
        <Tag
          className={className}
          style={{ ...textStyle, ...props.style }}
          onClick={onClick}>
          {children}
        </Tag>
      )}
    </>
  )
}

CommonText.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  tag: PropTypes.string,
  link: PropTypes.string,
}

export default CommonText
